<template>
  <form :class="`${isBoxed ? 'box' : ''}`" @submit.prevent="createUser" name="sign-up-form">
    <b-field label="First" :message="name_fMessage" :type="name_fMessage ? 'is-danger' : undefined">
      <b-input expanded icon="account" name="first" v-model="name_f" @input="name_fMessage = ''" placeholder="First" />
    </b-field>

    <b-field label="Last" :message="name_lMessage" :type="name_lMessage ? 'is-danger' : undefined">
      <b-input expanded icon="account-multiple" name="last" v-model="name_l" @input="name_lMessage = ''" placeholder="Last" />
    </b-field>

    <b-field label="Email" :message="emailMessage" :type="emailMessage ? 'is-danger' : undefined">
      <b-input icon="at" type="email" name="email" v-model="email" @input="emailMessage = ''" placeholder="you@example.com" />
    </b-field>

    <b-field v-if="showPhone" label="Phone" :message="phoneMessage" :type="phoneMessage ? 'is-danger' : undefined">
      <b-input icon="phone" name="phone" type="tel" v-model="phone" @input="phoneMessage = ''" placeholder="123-456-7891" />
    </b-field>

    <b-field label="Password" :message="passMessage" :type="passMessage ? 'is-danger' : undefined">
      <b-input v-model="pass" name="password" @input="passMessage = ''" type="password" icon="lock"></b-input>
    </b-field>
    <b-field label="Confirm Password" :type="!passwordsMatch ? 'is-danger' : ''">
      <b-input v-model="confirmedPass" name="confirm_password" type="password" icon="lock"></b-input>
    </b-field>

    <div class="buttons is-centered">
      <b-button :loading="loading" native-type="submit" :disabled="!canSubmit">
        Let's Go
      </b-button>
    </div>
  </form>
</template>

<script>
import {createProfile} from '@/utils/api';

export default {
  props: {
    isBoxed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      name_f: '',
      name_fMessage: '',

      name_l: '',
      name_lMessage: '',

      email: '',
      emailMessage: '',

      pass: '',
      passMessage: '',

      phone: '',
      phoneMessage: '',

      confirmedPass: '',
      loading: false,

      showPhone: !process.env.VUE_APP_NO_PHONE_ON_SIGN_UP
    }
  },
  methods: {
    createUser: function () {
      this.loading = true;

      let { name_f, name_l, email, pass, phone, showPhone } = this;
      let userDeets = {
        name_f,
        name_l,
        email,
        pass
      };

      if (showPhone) {
        userDeets.phone = phone;
      }

      createProfile(userDeets)
        .then(async res => {
          let resData = await res.json();

          if (!res.ok) {
            if ('for' in resData && (resData.for + 'Message') in this) {
              this[resData.for + 'Message'] = resData.message;
            }

            return this.$buefy.toast.open({
              message: resData.message,
              type: 'is-danger'
            });
          }

          console.log({resData});

          if ('usr' in resData) {
            localStorage.setItem('user', JSON.stringify(resData.usr));
            this.$emit('userUpdated', resData.usr);
            await this.$router.push('/');
          }

          return this.$buefy.toast.open({
            message: 'Account Created!',
            type: 'is-success'
          })
        })
        .catch(err => this.$buefy.toast.open({message: err.message, type: 'is-danger'}))
        .finally(() => this.loading = false);
    }
  },
  computed: {
    passwordsMatch: function () {
      if (!this.pass) {
        return true;
      }
      return this.pass && this.pass === this.confirmedPass;
    },
    canSubmit: function (){
      let requiredFields = [
        'email',
        'name_l',
        'name_f',
        this.showPhone ? 'phone' : ''
      ];

      let requiredMet = requiredFields
        .filter(field => field)
        .every(attr => this[attr] && !this[attr + 'Message']);

      return this.pass && this.passwordsMatch && requiredMet;
    }
  },
}
</script>